import api from "lib/api";

export const testConnectionSmtp = async (params = {}) => {
  return await api.post("v1/emailTemplateSetting/testEmailConnection", params);
};

export const createConnectionSmtp = async (params = {}) => {
  return await api.post("v1/emailTemplateSetting/createEmailConnection", params);
};

export const SearchConnectionSmtp = async (params = {}) => {
  if (params.requestId && (params.companyId) && (params.employeeId))
    return await api.post("v1/emailTemplateSetting/SearchEmailConnection", params);
};

export const DeleteConnectionSmtp = async (params = {}) => {
  return await api.post("v1/emailTemplateSetting/DeleteEmailConnection", params);
};

export const getCommonTypeByGroupType = async (params = {}) => {
  return await api.post("/v1/dropdown/getCommonTypeByGroupType", params);
};
